import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Box, Container, Theme, Typography, Grid } from '@material-ui/core';

interface ImplementedSolutionProps {
  text: string;
}

interface ImplementedSolutionArrayProps {
  textList: Array<ImplementedSolutionProps>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      fontWeight: 500,
      color: theme.palette.primary.dark,
      marginBottom: theme.spacing(4),
    },
    text: {
      marginTop: theme.spacing(2),
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: theme.palette.secondary.light,
      margin: theme.spacing(10, 0),
    },
  });
});

const ImplementedSolutionSection: FC<ImplementedSolutionArrayProps> = ({ textList }) => {
  const classes = useStyles();
  return (
    <Container fixed>
      <Grid container justify="center" direction="row">
        <Grid item lg={8} sm={12}>
          <Typography variant="h4" className={classes.title} data-aos="fade-up">
            Implemented Solution
          </Typography>
          <ul>
            {textList.map((item, index) => (
              <li key={index} data-aos="fade-up">
                <Typography className={classes.text}>{item.text}</Typography>
              </li>
            ))}
          </ul>
          <Box className={classes.divider} />
        </Grid>
      </Grid>
    </Container>
  );
};
export default ImplementedSolutionSection;
